// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiRequestSearchBase {
    static getAttributeTypeMap() {
        return MedicalBiRequestSearchBase.attributeTypeMap;
    }
}
MedicalBiRequestSearchBase.discriminator = undefined;
MedicalBiRequestSearchBase.additionalProperties = false;
MedicalBiRequestSearchBase.attributeTypeMap = [
    {
        "name": "request",
        "baseName": "request",
        "type": "MedicalBiRequestBase"
    },
    {
        "name": "transactionCorrelationId",
        "baseName": "transactionCorrelationId",
        "type": "number"
    },
    {
        "name": "transactionDateTime",
        "baseName": "transactionDateTime",
        "type": "Date"
    },
    {
        "name": "transactionId",
        "baseName": "transactionId",
        "type": "string"
    },
    {
        "name": "transactionMessage",
        "baseName": "transactionMessage",
        "type": "string"
    },
    {
        "name": "transactionStatus",
        "baseName": "transactionStatus",
        "type": "boolean"
    },
];
//# sourceMappingURL=medicalBiRequestSearchBase.js.map